import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Paper from "@material-ui/core/Paper";
import ListItemText from "@material-ui/core/ListItemText";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import Grid from "@material-ui/core/Grid";
import {Enums} from "./Enums";
import {BASE_URL_MESSENGER_API, URL_GROUP_AVATAR} from "../../Const";
import {GroupRepository} from "../../Repository/GroupRepository";
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import {ImageLoader} from "./ImageLoader";
import {AudioPlayer} from "./AudioPlayer";
import IconButton from "@mui/material/IconButton";

export class ChatComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            chatList: [],
            avatar: null,
            title: "",
            lastSeen: "",
        }
    }


    componentDidMount() {
        switch (this.props.mode) {
            case Enums.ChatMode.CHANNEL:
                let groupInfo = GroupRepository.findByChatId(this.props.chat_id)

                this.setState({avatar: groupInfo.avatar, title: groupInfo.title})
                break

        }

        fetch(BASE_URL_MESSENGER_API + 'chats?chat_id=' + this.props.chat_id + '&target_timestamp=' + Date.now() + '&per_page=' + 100, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_messenger_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code == 200) {
                        this.setState({chatList: results.data.reverse()})
                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }


    renderItem = message => {
        // just standard if statement
        let content = JSON.parse(message.content)

        switch (content.type) {
            case "messageText":
                return (
                    <ListItem key={message.id} style={{
                        justifyContent: 'right',
                        alignItems: 'right',
                        marginRight: 15
                    }}>
                        <div>
                            <Paper style={{width: '100%'}}>
                                <ListItemText style={{align: 'right'}}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <p style={{
                                                margin: 0,
                                                overflow: 'ellipsis',
                                                whiteSpace: 'pre-wrap',
                                                color: 'black',
                                                padding: 8
                                            }}
                                               align='right'>{content.text.text}
                                            </p>
                                        </Grid>

                                    </Grid>


                                </ListItemText>

                            </Paper>

                        </div>

                    </ListItem>
                );


            case "messageImage":

                return (
                    <ListItem key={message.id} style={{width: 180}}>

                        <div>

                            <Paper
                                style={{
                                    width: content.imageStruct.width / 2,
                                    height: content.imageStruct.height / 2,
                                    marginRight: 15,
                                    marginBottom: 15,
                                    align: 'center',
                                    backgroundPosition: 'center',
                                }}>

                                <ImageLoader url={content.imageStruct.imageFile.remoteId}
                                             thumbnail={content.imageStruct.thumbnail}
                                             width={content.imageStruct.width} height={content.imageStruct.height}/>

                            </Paper>
                        </div>

                    </ListItem>
                );

            case "messageAudio":
                return (
                    <ListItem key={message.id} style={{width: 180}}>

                        <div>

                            <Paper
                                style={{
                                    marginRight: 15,
                                    marginBottom: 15,
                                    align: 'center',
                                    backgroundPosition: 'center',
                                }}>

                                <AudioPlayer url={content.audioStruct.audioFile.remoteId}/>


                            </Paper>
                        </div>

                    </ListItem>
                )

            case "messageVideo":

                return (
                    <ListItem key={message.id}>


                        <Paper
                            style={{
                                height: content.videoStruct.width / 6,
                                width: content.videoStruct.height / 6,
                                marginRight: 15,
                                marginBottom: 15,
                                align: 'center',
                            }}>

                            <video style={{
                                height: "100%",
                                width: "100%",
                            }} controls>
                                <source src={content.videoStruct.videoFile.remoteId} type="video/mp4"/>
                            </video>


                        </Paper>

                    </ListItem>
                )
        }
    }

    render() {
        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        {this.state.avatar == null ?
                            <IconButton style={{color: 'black'}}> <CampaignOutlinedIcon/></IconButton> :
                            <img style={{
                                borderRadius: '50%',
                                marginTop: '8px',
                                width: 46,
                                height: 46
                            }}
                                 alt="avatar2"
                                 src={URL_GROUP_AVATAR + this.state.avatar}/>}


                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }}>{this.state.title}</strong></ListItemText>

                    </ToolbarMui>

                </AppBar>


                <List style={{marginTop: 70}}> {this.state.chatList.map(this.renderItem)}
                </List>

            </React.Fragment>
        )


    }

}
